// extracted by mini-css-extract-plugin
export default {"top":"_1wPUq","bottom":"_2th7-","top-wrap":"_1r33X","topWrap":"_1r33X"};